import { Card as AntCard } from "antd";
import styled from "styled-components";

export const Card = styled(AntCard)`
    position: relative;
    width: 300px;
    min-width: 300px;
    height: 400px;
    max-height: 400px;
    border-radius: 12px;
    font-family: 'Futura';
    overflow: hidden;
    @media (max-width: 500px) {
        width: 100%;
        min-width: 100%;
    }
    &:hover {
        ${({hoverable})=> hoverable ? 'box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);' : ''}
    }

`;

export const NewsInfo = styled.div`
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 9px 18px;
    background-color: #fff;
    color: #888;
`;

export const NewsInfoItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    font-size: 16px;
    gap: 4px;
`;

export const NewsInfoItemText = styled.span`
    font-size: 16px;
`;
